import ShowVM from './show-vm';
export default {
  init: function(){
    console.log('Initializing Kadenze.CommonResourceShow');

    //Following options explained here: https://github.com/Knockout-Contrib/Knockout-Validation/wiki/Configuration
    var data = JSON.parse($('#resourcing_json').val());
    ko.applyBindings(new ShowVM(data), document.getElementById('resource-show'));
  }
};
